import React, { Dispatch } from "react";
import { ToolbarState } from "./toolbarContext.types";
import { ToolbarAction } from "./toolbarReducer.types";

export const initialState = {
  toolbarSchema: [],
  measureInProgress: true,
  settingVisibilityInProgress: true,
  isSmallScreen: false,
  closeShowMoreDropdown: false,
  closeAllToolbarItemDropdowns: false,
};

export const ToolbarContext = React.createContext<{
  state: ToolbarState;
  dispatch: Dispatch<ToolbarAction>;
}>({ state: initialState, dispatch: () => null });
